import { createSlice } from "@reduxjs/toolkit";
// import storage from "../../services/storage";

//const token = storage.get("classToken") || "";

const initialState = [
  {
    name: "multiple choice",
    type: "mcqs",
    image: "mult_choice",
  },
  {
    name: "long response",
    type: "fr",
    image: "free_response",
  },
  {
    name: "fill-in-the-blank",
    type: "blanks",
    image: "fill_in_the_blank",
  },
  // {
  //   name: "matching",
  //   type: "matching",
  //   image: "matching",
  // },
  {
    name: "true or false",
    type: "truefalse",
    image: "mult_choice",
  },
  {
    name: "short response",
    type: "sa",
    image: "fill_in_the_blank",
  },
  // {
  //   name: "order list",
  //   type: "orderlist",
  //   image: "order_list",
  // },
  // {
  //   name: "multi select",
  //   type: "multiselect",
  //   image: "order_list",
  // },
];

const slice = createSlice({
  name: "templates",
  initialState,

  reducers: {},
});

// export const { setTopScroll, setClientX, setChapter, setSection } = slice.actions;
export default slice.reducer;
